'use client';

import { useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';

export function NavigationProgress() {
  const pathname = usePathname();
  const [visible, setVisible] = useState(false);
  const [width, setWidth] = useState(0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const prevPathname = useRef(pathname);

  useEffect(() => {
    if (pathname === prevPathname.current) return;
    prevPathname.current = pathname;

    // Start progress
    setWidth(0);
    setVisible(true);

    // Quickly jump to 80%, then finish after a short delay
    const t1 = setTimeout(() => setWidth(80), 30);
    const t2 = setTimeout(() => setWidth(100), 300);
    const t3 = setTimeout(() => setVisible(false), 600);

    timerRef.current = t3;
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      clearTimeout(t3);
    };
  }, [pathname]);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-0.5 bg-transparent pointer-events-none">
      <div
        className="h-full"
        style={{
          width: `${width}%`,
          backgroundColor: 'var(--teal)',
          transition: width === 0 ? 'none' : 'width 0.3s ease',
          boxShadow: '0 0 8px color-mix(in srgb, var(--teal) 50%, transparent)',
        }}
      />
    </div>
  );
}
